import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import {
  Alert,
  Button,
  TextField,
} from '@a-ui/react';

import * as cardActions from 'actions/card';
import formatCurrency from 'helpers/formatCurrency';
import getEnvironment from 'helpers/getEnvironment';

const CardCharge = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const card = useSelector(state => state.card);

  const [amount, setAmount] = useState('');

  useEffect(() => {
    if (!card.cardNumber) {
      navigate('/?fromUrl=/opladen');
    } else if (!card) {
      dispatch(cardActions.getCard({
        cardType: card.cardType,
        cardNumber: card.cardNumber
      }));
    }
  }, [card, dispatch, navigate]);

  useEffect(() => {
    if (card.charged) {
      const env = getEnvironment();
      const urls = {
        local: 'https://winkelmand-o.antwerpen.be',
        dev: 'https://winkelmand-o.antwerpen.be',
        acc: 'https://winkelmand-a.antwerpen.be',
        prod: 'https://winkelmand.antwerpen.be'
      };
      window.location.href = urls[env] || urls.prod;
    }
  }, [card.charged]);

  const handleAmountChange = (e) => {
    setAmount(e.target.value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(cardActions.chargeCard({
      cardNumber: card.cardNumber,
      cardType: card.cardType,
      amount
    }));
  };

  const handleCancel = () => {
    navigate('/overzicht');
  };

  return (
    <div className="row">
      <div className="col-md-8 col-md-offset-2 col-xs-12">
        <div className="box">
          <h4>Sorteerpas opladen</h4>
          <form className="u-margin-top" onSubmit={handleSubmit}>
            {card.error && (
              <div className="u-margin-bottom">
                <Alert type="danger">
                  <div dangerouslySetInnerHTML={{ __html: card.error }} />
                </Alert>
              </div>
            )}
            <h5 className="u-margin-bottom-xs">Gegevens</h5>
            <dl className="a-definition-list u-margin-bottom-xs">
              <dt>Kaartnummer</dt>
              <dd>{card.cardNumber}</dd>

              <dt>Kaarthouder</dt>
              <dd>{card.cardHolder || <em>Onbekend</em>}</dd>

              <dt>Huidig saldo</dt>
              <dd>{formatCurrency(card.amount)}</dd>
            </dl>

            <h5 className="u-margin-bottom-xs">Opladen</h5>
            <div className="a-input a-input--inline has-icon-left">
              <p className="u-margin-bottom-xs">
                Laad hier uw pas meteen <strong>online</strong> op:
              </p>
              <TextField
                addOn={{
                  content: '€',
                  placement: 'left',
                  type: 'text'
                }}
                label="Op te laden bedrag"
                value={amount}
                onChange={handleAmountChange}
                type="number"
              />
              <small>Minimum &euro; 0,10</small>
            </div>

            <div className="u-margin-top u-margin-bottom">
              <Button
                disabled={!amount || card.loading}
                htmlType="submit"
                {...(card.loading
                  ? { addOn: { type: 'spinner' } }
                  : { addOn: { type: 'icon', align: 'left', iconProps: { name: 'credit-card-1' } } })}
              >
                Opladen
              </Button>
              <Button emphasis="low" onClick={handleCancel}>Annuleren</Button>
            </div>
            <hr />

            <p>Of via een <strong>bankoverschrijving</strong>:</p>
            <dl className="a-definition-list">
              <dt>Rekeningnummer</dt>
              <dd>BE53 0961 1004 0053</dd>
              <dt>Gestructureerde mededeling</dt>
              <dd>{card.ogm}</dd>
            </dl>
            <em>Opgelet! De verwerking van een bankoverschrijving kan tot 5 dagen duren.</em>
          </form>
        </div>
      </div>
    </div>
  );
};

export default CardCharge;